<template>
  <div>
    <c-options class="options" v-model:value="region" :options="regions"
               :placeholder="$t('store.selectRegion')"/>
    <c-options class="options" v-model:value="store" :options="filteredStores"
               :placeholder="$t('store.select')"/>
  </div>
</template>
<script>
import OptionsDropdown from '@/components/form/OptionsDropdown';

export default {
  name: 'StoreForm',

  mixins: [],

  props: {
    store: { required: true },
    region: { required: true },
  },

  components: {
    'c-options': OptionsDropdown,
  },

  created() {
    this.fetchStores();
    this.fetchRegions();
  },

  data() {
    return {
      stores: [],
      regions: [],
    };
  },

  computed: {
    filteredStores() {
      if (!this.region) {
        return [];
      }

      return this.stores.filter((store) => store.region_id === this.region.id)
        .map((store) => {
          return {
            id: store.id,
            value: store[`name_${this.$i18n.locale}`]
          };
        });
    },
  },

  watch: {
    store() {
      this.$emit('update:store', this.store);
    },

    region() {
      this.$emit('update:region', this.region);
      this.$emit('update:store', null);
    }
  },

  methods: {
    async fetchStores() {
      this.stores = await this.$store.dispatch('getStores');
    },

    async fetchRegions() {
      const data = await this.$store.dispatch('getRegions');
      this.regions = data.map((region) => {
        return {
          id: region.id,
          value: region.name[this.$i18n.locale]
        };
      });
    }
  }
};
</script>
<style scoped>
.options + .options {
  margin-top: 20px;
}
</style>
